export default __webpack_public_path__ + "static/media/health_savings_account_light.647d23ad.png";